import { GalleriaDesignTokens } from '@primeuix/themes/aura/galleria';

export const galleriaTokens: GalleriaDesignTokens = {
  root: {
    borderWidth: '1px',
    borderColor: '{content.border.color}',
    borderRadius: '{content.border.radius}',
    transitionDuration: '{transition.duration}',
  },
  navButton: {
    background: 'rgba(255, 255, 255, 0.1)',
    hoverBackground: 'rgba(255, 255, 255, 0.2)',
    hoverColor: '{surface.0}',
    color: '{surface.100}',
    size: '3rem',
    gutter: '0.5rem',
    prev: {
      borderRadius: '{galleria.nav.button.size} / 2',
    },
    next: {
      borderRadius: '{galleria.nav.button.size} / 2',
    },
    focusRing: {
      width: '{focus.ring.width}',
      style: '{focus.ring.style}',
      color: '{focus.ring.color}',
      offset: '{focus.ring.offset}',
      shadow: '{focus.ring.shadow}',
    },
  },
  navIcon: {
    size: '1.5rem',
  },
  thumbnailsContent: {
    background: '{content.background}',
    padding: '1rem 0.25rem',
  },
  thumbnailNavButton: {
    size: '2rem',
    borderRadius: '{content.border.radius}',
    gutter: '0.5rem',
    focusRing: {
      width: '{focus.ring.width}',
      style: '{focus.ring.style}',
      color: '{focus.ring.color}',
      offset: '{focus.ring.offset}',
      shadow: '{focus.ring.shadow}',
    },
    hoverBackground: '{content.hover.background}',
    hoverColor: '{text.hover.color}',
    color: '{text.muted.color}',
  },
  thumbnailNavButtonIcon: {
    size: '1rem',
  },
  indicatorList: {
    padding: '1rem',
    gap: '0.5rem',
  },
  indicatorButton: {
    width: '1rem',
    height: '1rem',
    borderRadius: '{indicatorButton.width} / 2',
    activeBackground: '{primary.color}',
    focusRing: {
      width: '{focus.ring.width}',
      style: '{focus.ring.style}',
      color: '{focus.ring.color}',
      offset: '{focus.ring.offset}',
      shadow: '{focus.ring.shadow}',
    },
  },
  insetIndicatorList: {
    background: 'rgba(0, 0, 0, 0.5)',
  },
  insetIndicatorButton: {
    background: 'rgba(255, 255, 255, 0.4)',
    hoverBackground: 'rgba(255, 255, 255, 0.6)',
    activeBackground: 'rgba(255, 255, 255, 0.9)',
  },
  closeButton: {
    size: '3rem',
    gutter: '0.5rem',
    background: 'rgba(255, 255, 255, 0.1)',
    hoverBackground: 'rgba(255, 255, 255, 0.2)',
    color: '{surface.50}',
    hoverColor: '{surface.0}',
    borderRadius: '{closeButton.size} / 2',
    focusRing: {
      width: '{focus.ring.width}',
      style: '{focus.ring.style}',
      color: '{focus.ring.color}',
      offset: '{focus.ring.offset}',
      shadow: '{focus.ring.shadow}',
    },
  },
  closeButtonIcon: {
    size: '1.5rem',
  },
  caption: {
    background: 'rgba(0, 0, 0, 0.5)',
    color: '{surface.100}',
    padding: '1rem',
  },
};
